import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api, auth } from '@/lib/api';

const SESSION_KEY = 'apexflow:readiness-green-fired';

/**
 * useReadinessSignal — polls /intel/promotion-console every 60s
 * (admin-only) and exposes {readiness_pct, level, anyEligible}.
 *   level: 'green' (≥80) · 'amber' (≥50) · 'red' (>0) · 'hidden' (0/no data)
 * Silently no-ops for non-admin sessions.
 */
export default function useReadinessSignal() {
  const [state, setState] = useState({
    readiness_pct: 0, level: 'hidden', anyEligible: false,
    allEligible: false, loaded: false,
  });

  useEffect(() => {
    const u = auth.currentUser();
    if (!u || u.role !== 'admin') return undefined;
    let active = true;
    const fetchIt = async () => {
      try {
        const r = await api.get('/intel/promotion-console');
        if (!active) return;
        const pct = Number(r.data?.readiness_pct || 0);
        const level = pct >= 80 ? 'green'
          : pct >= 50 ? 'amber'
            : pct > 0 ? 'red' : 'hidden';
        // First green-tier crossing in this session → admin nudge.
        if (level === 'green' &&
            sessionStorage.getItem(SESSION_KEY) !== '1') {
          sessionStorage.setItem(SESSION_KEY, '1');
          try {
            toast.success(
              `Promotion readiness ${pct}% — all gates clear`,
              {
                description: 'Open the Promotion Console to '
                  + 'review and act.',
                duration: 12000,
                action: {
                  label: 'OPEN',
                  onClick: () => {
                    window.location.assign('/promotion-console');
                  },
                },
              });
          } catch (e) { /* toast may not be mounted yet */ }
        }
        setState({
          readiness_pct: pct,
          level,
          anyEligible: !!r.data?.any_eligible,
          allEligible: !!r.data?.all_eligible,
          loaded: true,
        });
      } catch (e) { /* silent */ }
    };
    fetchIt();
    const t = setInterval(fetchIt, 60_000);
    return () => { active = false; clearInterval(t); };
  }, []);

  return state;
}
